import React, { useEffect, Fragment, useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { loadUserGroups } from "../actionCreators";
import UserGroupsComponent from "./UserGroupsComponent";
import { useQueryWithErrorHandling } from "customHooks/errorHandling";
import { USER_GROUPS_QUERY } from "../../queries";

export const UserGroupsContainer = ({ actions, userGroups }) => {
  const [expanded, setExpanded] = useState(true);
  useEffect(() => {
    actions.loadUserGroups();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (userGroups.loaded) {
      actions.loadUserGroups();
    }
  }, [userGroups.loaded]); // eslint-disable-line react-hooks/exhaustive-deps

  const { data } = useQueryWithErrorHandling(USER_GROUPS_QUERY);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <Fragment>
      {data?.userGroups && (
        <UserGroupsComponent userGroups={data.userGroups} toggleExpanded={toggleExpanded} expanded={expanded} />
      )}
    </Fragment>
  );
};

UserGroupsContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  userGroups: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    userGroups: state.userProfile.userGroups
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        loadUserGroups
      },
      dispatch
    )
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(UserGroupsContainer);
